import React, { Component, createRef } from 'react'
import SimpleBar from 'simplebar-react'
import AddListItemButton from './AddListItemButton'
import './NavigationListBar.scss'

class NavigationListBar extends Component {
    constructor(props) {
        super(props)
        this.scrollableNodeRef = createRef()
    }

    onAddClick = async () => {
        const node = this.scrollableNodeRef.current
        await this.props.onClickAddNew()
        const top = node.scrollHeight - node.clientHeight
        node.scrollTo({
            top: top,
            left: 0,
            behavior: 'auto',
        })
    }

    render() {
        const { titleOfItem, items, focusedItemId, maxLength, onClickItem } = this.props

        const getIcon = _item => {
            return _item.coverImage ? (
                <div
                    className={`navigation-list-bar__item-icon ${focusedItemId === _item.id ? ' is-active' : ''}`}
                    style={{ backgroundImage: `url(${_item.coverImage})` }}
                />
            ) : null
        }

        const isAllowedAdd = items.length < maxLength
        return (
            <SimpleBar
                autoHide={false}
                style={{ maxHeight: '100%' }}
                scrollableNodeProps={{ ref: this.scrollableNodeRef }}
            >
                <div className="navigation-list-bar">
                    {items.length ? (
                        <ul className="nav">
                            {items.map((item, index) => {
                                return (
                                    <li key={item.id}>
                                        {getIcon(item)}
                                        <div
                                            className={`text${focusedItemId === item.id ? ' is-active' : ''}`}
                                            onClick={() => onClickItem(item.id)}
                                        >
                                            {titleOfItem + ' ' + (index + 1)}
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    ) : null}
                    {isAllowedAdd ? <AddListItemButton length={items.length} onClick={this.onAddClick} /> : null}
                </div>
            </SimpleBar>
        )
    }
}

export default NavigationListBar
